import Icon from './Icon';

const PhoneList = ({ phones, title }: { phones: string[]; title: string }) => {
  return (
    <div className="py-4 md:p-0">
      <h2 className="text-lg font-bold mb-4">{title}</h2>
      <ul className="list-none list-inside">
        {phones.map((phone, index) => (
          <li key={index} className="mb-2 py-1">
            <a href={`tel:${phone}`} className="text-theme-link flex items-center gap-2">
              <div>
                <Icon name="phone" />
              </div>
              <div>{phone}</div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default PhoneList;
